import { useQuery, useMutation } from "react-query";
import { getApplicationOrderNecessity, getApplicationOrderNecessityPDF, getLookups } from "@/api/ApplicationOrders/get-oa-necessity";

const key = "application-order-necessity";

export function useApplicationOrderNecessity(codes, estateIds) {
	return useQuery([key, codes, estateIds], () => getApplicationOrderNecessity(codes, estateIds), {
		enabled: codes !== "" && estateIds && estateIds.length > 0,
	});
}

export function useApplicationOrderNecessityPDF() {
	return useMutation(getApplicationOrderNecessityPDF, {
		onSuccess: (response, variables) => {
			const href = URL.createObjectURL(response);
			const codes = variables?.codes || "OAs";

			const link = document.createElement("a");
			link.href = href;
			link.setAttribute("download", `Necesidad de compra OAs ${codes}.pdf`);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		},
	});
}

export function useApplicationOrderNecessityLookups() {
	return useQuery([key, "lookups"], () => getLookups());
}
